const htmlBody = document.querySelector('#filmConsider_card').querySelector('div[name=lastOpenedActivity]');
import auth from '../tools/storage.js';

import tools from '../tools/tools.js';
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    htmlBody.innerHTML = '';
  },

  getElement(item, index) {
  let iRemoveBlock = '';
  let newMsg = '';



  return `<div class = "lastActivityCloud column p-1 m-1">
            <b class="m-0 p-0 w-100 row"><div class="countVisit">${item.count}</div>${item.name}</b>
            <i>${item.time}</i>
          </div>`;
  },

  ifnull (someData) {
    return (someData)? someData : '';
  },

  drawDataInContainer(dataToDisplay) {

    this.cleanContainer();
    if (dataToDisplay)
      dataToDisplay.forEach((item, index) => htmlBody.insertAdjacentHTML('beforeend', this.getElement(item, index)));
    
  },

  drawMarkupInContainer(markup) {
    htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};
